<template>
  <div class="container">
    <div class="header">
      <navBar></navBar>
    </div>
    <div class="main-wrapper">
      <div class="card">
        <div class="aside">
          <el-menu class="el-menu" router :default-active="$route.path" @open="open" @close="open">
            <myitem :data="routes[0].children"></myitem>
          </el-menu>
        </div>
      </div>
      <div class="main">
        <router-view :key="$route.path"> </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import myitem from "./menuItem/index.vue";
import gzhPCRouter from "@/router/gzh/pc";
import navBar from "./headerLogo/index.vue";
export default {
  name: "gzhpc",
  components: {
    myitem,
    navBar
  },
  data() {
    return {};
  },
  computed: {
    routes() {
      return gzhPCRouter;
    }
  },
  mounted() {},
  methods: {
    open(key) {
      this.$router.push(key);
    }
  }
};
</script>

<style lang="scss">
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .header {
    padding: 0;
    height: 112px;
  }
  .main-wrapper {
    flex: 1;
    display: flex;
    .card {
      width: 450px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      overflow: hidden;
      color: #303133;
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    }
    .aside {
      height: 100%;
      background-color: white;
      color: #333;
      text-align: center;
      line-height: 200px;
      &::-webkit-scrollbar {
        display: none;
      }
      .el-menu {
        border: 0;
        width: 450px;
        color: #18191E;
        .el-menu-item {
          text-align: left;
          display: flex;
          align-items: center;
        }
        .el-submenu__title {
          text-align: left;
        }
        .el-menu-item.is-active {
          border-left: 6px solid #008754;
          border-top-left-radius:5px;
          border-bottom-left-radius:5px;
          i {
            color: #f7f9fa;
          }
          span {
            color: #008754;
          }
        }
        span {
          font-size: 29px;
          white-space: normal;
          word-break: break-all;
          line-height: 30px;
          // flex: 1;
        }
      }
    }
    .main {
      width: calc(100% - 450px);
    }
  }
}
</style>
